<template>
  <div class="animated fadeIn reports">
    <b-card no-body bg-variant="light" class="received-form">
      <b-row slot="header" class="p-0 d-flex align-items-center">
        <b-col md="3" class="col" style="z-index: 100;">
          <multiselect class="custom-multiselect" :limit="1" placeholder="Filter by Username" :options="setUsernames" track-by="text" label="text" v-model="usernames" :multiple="true"></multiselect>
        </b-col>
        <b-col md="3" class="col" style="z-index: 100;">
          <b-input-group>
            <b-form-input @input="filterBySearch" ref="searchInput" placeholder="Search by File Name/ Status"/>
          </b-input-group>
        </b-col>
        <b-col md="3" class="col">
          <b-row class="d-flex align-items-center">
            <b-col md="1.5" class="mt-auto">
              <h6>{{ $t('COMMON.DATE_RANGE') }}</h6>
            </b-col>
            <b-col md="4">
              <date-picker range v-model="dateRange" lang="en" :shortcuts="shortcuts" format="YYYY-MM-DD" append-to-body :clearable="false" width="210px"></date-picker>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3" class="col">
          <b-row>
            <div>
              <b-button v-on:click="fetchProcessedForms" class="mt-auto" style="margin-right: 3px;">Fetch</b-button>
              <b-button v-on:click="clearFilters" class="mt-auto" style="margin-right: 3px;">Clear</b-button>
              <b-dropdown no-caret class="mt-1 panel-option">
                  <template slot="button-content">
                    <div><i class="fa fa-cloud-download" aria-hidden="true"></i></div>
                  </template>
                  <b-dropdown-item v-on:click="downloadFormsInsights">Download</b-dropdown-item>
                  <b-dropdown-item v-on:click="downloadAllFormLogs">Download View Logs</b-dropdown-item>
                </b-dropdown>
            </div>
          </b-row>
        </b-col>
      </b-row>
      <div class="forms-table">
        <b-table show-empty striped :empty-text="$t('COMMON.NO_RECORD')" hover responsive="sm" variant="danger" v-if="showProcessedForms" :filter="searchFilter" :items="dailyReports" :fields="tableFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
          <template slot="HEAD_title" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="title" slot-scope="data"><span v-b-tooltip.hover.d100.topleft.viewport :title="data.item.title">{{data.item.title}}</span></template>
          <template slot="HEAD_username" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="username" slot-scope="data"><span v-b-tooltip.viewport :title="data.item.username">{{data.item.username}}</span></template>
          <template slot="HEAD_document_type" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="document_type" slot-scope="data"><span v-b-tooltip.viewport :title="data.item.document_type">{{data.item.document_type}}</span></template>
          <template slot="HEAD_total_page_count" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_average_confidence" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_total_fields" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_transcribed_fields" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_accuracy_percentage" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_edited_fields" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_status" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="status" slot-scope="data"><span v-b-tooltip.viewport :title="data.item.status">{{data.item.status}}</span></template>
          <template slot="HEAD_created_at" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="created_at" slot-scope="data"><span v-b-tooltip.viewport :title="data.item.created_at">{{data.item.created_at}}</span></template>
          <template slot="HEAD_updated_at" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="updated_at" slot-scope="data"><span v-b-tooltip.viewport :title="data.item.updated_at">{{data.item.updated_at}}</span></template>
          <template slot="HEAD_document_recieved_at" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="document_recieved_at" slot-scope="data"><span v-b-tooltip.viewport :title="data.item.document_recieved_at">{{data.item.document_recieved_at}}</span></template>
          <template slot="HEAD_time_difference" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_actions" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="actions" slot-scope="data">
            <div class="btn btn-group">
              <b-button class="btn-primary btn-sm" style="margin-right: 7px;" v-b-tooltip.hover.viewport title="View Logs" @click="showLogs(data.item.id, 1)"><i class="fa fa-file" aria-hidden="true"></i></b-button>
              <b-button class="btn-primary btn-sm" v-b-tooltip.hover.viewport title="Download CSV" @click="downloadFormLogs(data.item.id, data.item.title)"><i class="icon-cloud-download"></i></b-button>
            </div>
          </template>
        </b-table>
        <content-placeholders v-else >
          <content-placeholders-text :lines="12"/>
        </content-placeholders>
        <infinite-loading
          :distance="distance"
          spinner="spiral"
          @infinite="dailyReportsInfinetHandler"
          ref="infiniteLoading">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </b-card>
    <b-modal title="Form Logs" size="lg" ref="formLogsTable" @hidden="auditLogs = [], isLogsLoaded = false" centered>
      <b-container fluid>
        <div class="forms-table" v-if="auditLogs.length && isLogsLoaded">
          <b-table striped hover :bordered="true" :fields="logFields" :items="auditLogs" :per-page="logsPerPage" :current-page="logsCurrentPage" aria-controls="logs-table">
            <template slot="file_name" slot-scope="data"><span class="ellipsis" v-b-tooltip.hover.d100.topleft.viewport :title="data.item.file_name">{{data.item.file_name}}</span></template>
            <template slot="field_name" slot-scope="data"><span class="ellipsis" v-b-tooltip.hover.d100.topleft.viewport :title="data.item.field_name">{{data.item.field_name}}</span></template>
            <template slot="original_text" slot-scope="data"><span class="ellipsis" v-b-tooltip.hover.d100.topleft.viewport :title="data.item.original_text">{{data.item.original_text}}</span></template>
            <template slot="modified_text" slot-scope="data"><span class="ellipsis" v-b-tooltip.hover.d100.topleft.viewport :title="data.item.modified_text">{{data.item.modified_text}}</span></template>
            <template slot="updated_by" slot-scope="data"><span class="ellipsis" v-b-tooltip.hover.d100.topleft.viewport :title="data.item.updated_by">{{data.item.updated_by}}</span></template>
            <template slot="updated_at" slot-scope="data"><span class="ellipsis" v-b-tooltip.hover.d100.topleft.viewport :title="data.item.updated_at">{{data.item.updated_at}}</span></template>
          </b-table>
          <b-pagination align="center" id="logs-table" v-model="logsCurrentPage" :total-rows="logsRow" :per-page="logsPerPage"></b-pagination>
        </div>
        <div v-else-if="isLogsLoaded">
            No logs available
          </div>
        <div v-else>
          <content-placeholders >
            <content-placeholders-img style="height: 765px"/>
          </content-placeholders>
        </div>
      </b-container>
      <div slot="modal-footer">
          <b-btn size="sm" variant="dark" @click="$refs.formLogsTable.hide()"> Close </b-btn>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import router from '../../router'
import InfiniteLoading from 'vue-infinite-loading'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
export default {
  name: 'audit-log-report',
  data () {
    return {
      tableFields: [
        { key: 'actions', label: 'Actions', sortable: false },
        { key: 'id', sortable: true, thStyle: { width: '3%' } },
        { key: 'title', label: 'WORKFLOW.TITLE', sortable: true, thStyle: { width: '17%' } },
        { key: 'username', lavel: 'COMMON.USERNAME', sortable: true, thStyle: { width: '10%' } },
        { key: 'document_type', lavel: 'WORKFLOW.DOCUMENT_TYPE', sortable: true, thStyle: { width: '7%' } },
        { key: 'total_page_count', label: 'ANALYTICS.PAGES', sortable: true, thStyle: { width: '4%' } },
        { key: 'total_fields', label: 'ANALYTICS.TOTAL_FIELDS', sortable: false },
        { key: 'average_confidence', label: 'FORMS.CON_SCORE', sortable: true, thStyle: { width: '7%' } },
        { key: 'transcribed_fields', label: 'ANALYTICS.TRANSCRIBED_FIELDS', sortable: false },
        { key: 'edited_fields', label: 'ANALYTICS.EDITED_FIELDS', sortable: false },
        { key: 'status', label: 'COMMON.STATUS', sortable: true, thStyle: { width: '5%' } },
        { key: 'accuracy_percentage', label: 'ANALYTICS.ACCURACY_PERCENTAGE', sortable: true, thStyle: { width: '10%' } },
        { key: 'actions', label: 'Actions', sortable: false },
        { key: 'time_difference', label: 'WORKFLOW.TURN_AROU_TIME', sortable: true, thStyle: { width: '8%' } },
        { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: true, thStyle: { width: '10%' } },
        { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: true, thStyle: { width: '10%' } },
        { key: 'document_recieved_at', label: 'WORKFLOW.DOC_RECIEVED_AT', sortable: true, thStyle: { width: '10%' } }
      ],
      logFields: [
        { key: 'version', label: 'Version', thStyle: { width: '1%' } },
        { key: 'file_name', label: 'File Name', thStyle: { width: '20%' } },
        { key: 'field_name', label: 'Field Name', thStyle: { width: '20%' } },
        { key: 'original_text', label: 'Original Text', thStyle: { width: '20%' } },
        { key: 'modified_text', label: 'Modified Text', thStyle: { width: '20%' } },
        { key: 'updated_by', label: 'Updated By', thStyle: { width: '20%' } },
        { key: 'updated_at', label: 'Updated Date & Time', thStyle: { width: '20%' } },
        { key: 'original_confidence_score', label: 'Original Confidence Score', thStyle: { width: '10%' } },
        { key: 'modified_confidence_score', label: 'Modified Confidence Score', thStyle: { width: '10%' } }
      ],
      sortBy: 'id',
      sortDesc: true,
      showProcessedForms: false,
      dailyReports: [],
      distance: Infinity,
      lastFormId: -1,
      dateRange: [moment().startOf('week'), moment()],
      userOptions: [],
      usernames: null,
      searchFilter: '',
      auditLogs: [],
      logsCurrentPage: 1,
      logsPerPage: 13,
      formDocId: null,
      isLogsLoaded: false,
      shortcuts: [
        { text: 'Today',
          onClick: () => {
            this.dateRange = [moment().startOf('day'), moment()]
            return Date()
          }
        },
        {
          text: 'This Week',
          onClick: () => {
            this.dateRange = [moment().startOf('week'), moment()]
            return new Date()
          }
        },
        {
          text: 'Previous Week',
          onClick: () => {
            this.dateRange = [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week').startOf('day')]
            return new Date()
          }
        },
        {
          text: 'This Month',
          onClick: () => {
            this.dateRange = [moment().startOf('month'), moment()]
            return new Date()
          }
        },
        {
          text: 'Previous Month',
          onClick: () => {
            this.dateRange = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month').startOf('day')]
            return new Date()
          }
        }
      ]
    }
  },
  components: {
    'date-picker': DatePicker,
    InfiniteLoading,
    Multiselect
  },
  computed: {
    ...mapGetters(['idToken', 'accountId', 'isAdminRole', 'localTime']),
    setUsernames () {
      let usernames = []
      let updatedUsersArray = this.userOptions.map(user => ({
        value: Number(user.id),
        text: user.username
      }))
      usernames.push(...updatedUsersArray)
      return usernames
    },
    logsRow () {
      return this.auditLogs.length
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('DD MMMM YYYY HH:mm:ss')
    }
  },
  created () {
    this.fetchUsers()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.isAdminRole) {
        next()
      } else {
        router.replace('/Not-Found-404')
      }
    })
  },
  methods: {
    dailyReportsInfinetHandler ($state) {
      let payload = {
        last_form_id: this.lastFormId,
        start_date: moment(this.dateRange[0]).format('YYYY-MM-DD'),
        end_date: moment(this.dateRange[1]).format('YYYY-MM-DD'),
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null
      }
      if (this.usernames) {
        let userIds = []
        this.usernames.forEach(user => {
          userIds.push(Number(user.value))
        })
        payload.user_ids = userIds
      }
      if (this.searchFilter) {
        payload.search_query = this.searchFilter
      }
      Vue.axios.get('reports/daily_report', { headers: { Authorization: `Bearer ${this.idToken}` }, params: payload })
        .then(res => {
          let forms = res.data.forms_processed
          if (forms.length > 0) {
            this.distance = 100
            this.dailyReports = this.dailyReports.slice().concat(forms)
            this.lastFormId = forms[forms.length - 1]['id']
            this.formsProcessed = res.data.processed_by_agent_assist
            this.showProcessedForms = true
            this.sortBy = 'id'
            this.sortDesc = true
            $state.loaded()
          } else {
            this.distance = 100
            this.showProcessedForms = true
            $state.complete()
          }
        })
        .catch(error => {
          console.error(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchProcessedForms () {
      this.dailyReports = []
      this.distance = Infinity
      this.lastFormId = -1
      this.showProcessedForms = false
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
    },
    generateLogVersions (logsCount, pageNumber) {
      let logsPerPage = this.logsPerPage
      let startVersion = logsCount - logsPerPage * (pageNumber - 1)
      return Array(logsPerPage).fill().map((element, index) => startVersion - index)
    },
    showLogs (formDocId, selectedPage) {
      this.$refs.formLogsTable.show()
      let payload = {
        form_doc_id: formDocId,
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null
      }
      this.formDocId = formDocId
      Vue.axios.get('reports/audit_log', { headers: { Authorization: `Bearer ${this.idToken}` }, params: payload })
        .then(res => {
          let versions = this.generateLogVersions(res.data.result.length, selectedPage)
          this.logsCurrentPage = 1
          this.isLogsLoaded = true
          let fileName = res.data.file_name
          let logs = res.data.result
          let updatedLogs = []
          logs.forEach((log, logIndex) => {
            log.updates_data.forEach((update) => {
              updatedLogs.push({
                version: versions[logIndex],
                file_name: fileName,
                field_name: update.key,
                original_text: update.value_before,
                modified_text: update.value_after,
                updated_by: log.updated_by,
                updated_at: moment(log.created_at).format('MM/DD/YYYY, h:mm A'),
                original_confidence_score: update.original_confidence_score ? update.original_confidence_score : '',
                modified_confidence_score: update.modified_confidence_score ? update.modified_confidence_score : ''
              })
            })
          })
          this.auditLogs = updatedLogs
        })
        .catch(err => {
          console.error(err)
          if (err.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    logsPagination (selectedPage) {
      this.showLogs(this.formDocId, selectedPage)
    },
    downloadFormLogs (formDocId, fileName) {
      let payload = {
        form_doc_id: formDocId,
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null
      }
      let title = fileName + '_View Log'
      Vue.axios.post('reports/audit_log_csv.csv', payload, { headers: { 'Authorization': `Bearer ${this.idToken}` } })
        .then(res => {
          let csvData = res.data
          var downloadLink = document.createElement('a')
          downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData)
          downloadLink.download = title + '.csv'
          document.body.appendChild(downloadLink)
          downloadLink.click()
          downloadLink.remove()
        })
        .catch(error => {
          console.error(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    downloadAllFormLogs () {
      let payload = {
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null,
        start_date: moment(this.dateRange[0]).format('YYYY-MM-DD'),
        end_date: moment(this.dateRange[1]).format('YYYY-MM-DD'),
        search_query: this.searchFilter
      }
      if (this.usernames) {
        let userIds = []
        this.usernames.forEach(user => {
          userIds.push(Number(user.value))
        })
        payload.user_ids = userIds
      }
      let title = 'AuditLogReport_View Log' + payload.start_date + '_' + payload.end_date
      Vue.axios.post('reports/audit_view_all_logs.csv', payload, { headers: { 'Authorization': `Bearer ${this.idToken}` } })
        .then(res => {
          let csvData = res.data
          var downloadLink = document.createElement('a')
          downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData)
          downloadLink.download = title + '.csv'
          document.body.appendChild(downloadLink)
          downloadLink.click()
          downloadLink.remove()
        })
        .catch(error => {
          console.error(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    downloadFormsInsights () {
      let payload = {
        start_date: moment(this.dateRange[0]).format('YYYY-MM-DD'),
        end_date: moment(this.dateRange[1]).format('YYYY-MM-DD'),
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null
      }
      if (this.usernames) {
        let userIds = []
        this.usernames.forEach(user => {
          userIds.push(Number(user.value))
        })
        payload.user_ids = userIds
      }
      if (this.searchFilter) {
        payload.search_query = this.searchFilter
      }
      let title = 'Audit log report for the period_'
      Vue.axios.post('reports/form_insights.csv', payload, { headers: { 'Authorization': `Bearer ${this.idToken}` } })
        .then(res => {
          let csvData = res.data
          var downloadLink = document.createElement('a')
          downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData)
          downloadLink.download = title + payload.start_date + ' and ' + payload.end_date + '.csv'
          document.body.appendChild(downloadLink)
          downloadLink.click()
          downloadLink.remove()
        })
        .catch(error => {
          console.error(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchUsers () {
      let roleId = -1
      let accountId = -1
      Vue.axios.get('/admin/users/users_by_roles?role_id=' + roleId + '&account_id=' + accountId, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.userOptions = res.data.users
        })
        .catch(error => {
          console.error(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else if (error.status === 403) {
            Vue.toasted.show(this.$t('COMMON.UNAUTHORIZED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    filterBySearch (value) {
      this.searchFilter = value
    },
    clearFilters () {
      this.lastFormId = -1
      this.dailyReports = []
      this.searchFilter = ''
      this.usernames = null
      this.$refs.searchInput.$el.value = ''
      this.dateRange = [moment().startOf('week'), moment()]
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
    }
  }
}
</script>
<style lang="scss" scoped>
.reports {
  .card {
    cursor: pointer;
    background: #ebeef3;
    border-radius: 10px;
    .card-header {
      border-radius: 10px 10px 0 0;
      background-color: #e7e7e7;
      padding: 1rem;
    }
  }
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
}
.forms-table {
  max-height: 45rem;
  overflow-x: scroll;
  overflow-y: scroll;
  white-space: nowrap;
  border-radius: 0 0 10px 10px;
}
.ellipsis{
  display: inline-block;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: middle;
}
.result {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  padding: 5px;
}
/deep/ .custom-multiselect .multiselect__content-wrapper {
  box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.35) !important;
  border: 2px solid #e8e8e8;
  border-width: 1px 2px 3px 2px;
}
/deep/ .table.b-table>thead>tr>th.sorting_asc::after, table.b-table>thead>tr>th.sorting_desc::before, table.b-table>tfoot>tr>th.sorting_asc::after, table.b-table>tfoot>tr>th.sorting_desc::before {
    opacity: 1;
}
/deep/ .table.b-table>thead>tr>th.sorting::after, table.b-table>tfoot>tr>th.sorting::after {
    right: 0.25em;
    content: "\2193";
}
/deep/ .table.b-table>thead>tr>th.sorting::before, table.b-table>thead>tr>th.sorting::after, table.b-table>tfoot>tr>th.sorting::before, table.b-table>tfoot>tr>th.sorting::after {
    position: absolute;
    bottom: 3px;
    display: block;
    padding-bottom: inherit;
    font-size: inherit;
    line-height: 180%;
    transform: rotate(180deg);
}
/deep/ .table.b-table>thead>tr>th.sorting_asc::after, table.b-table>thead>tr>th.sorting_desc::before, table.b-table>tfoot>tr>th.sorting_asc::after, table.b-table>tfoot>tr>th.sorting_desc::before {
    opacity: 1;
}
/deep/ .table.b-table>thead>tr>th.sorting::before, table.b-table>tfoot>tr>th.sorting::before {
    right: 0.75em;
    content: "\2191";
}
/deep/ .table.b-table>thead>tr>th.sorting::after, table.b-table>thead>tr>th.sorting::before, table.b-table>tfoot>tr>th.sorting::after, table.b-table>tfoot>tr>th.sorting::before {
    position: absolute;
    bottom: 3px;
    display: block;
    padding-bottom: inherit;
    font-size: inherit;
    line-height: 180%;
    transform: rotate(180deg);
}
table {
  border-collapse: collapse;
  border-spacing: 0 0em;
}
 /deep/ .table td {
  padding: 3px !important;
  max-width: 95px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .table th, td {
  padding: 6px !important;
}
/deep/ .small-cell-width{
  min-width: 90px;
}
/deep/ .medium-cell-width{
  min-width: 150px;
}

/deep/ .large-cell-width{
  min-width: 200px;
}

/deep/ .semi-medium-cell-width{
  min-width: 140px;
}
/deep/ .small-cell-width{
  min-width: 90px
}
/deep/ .medium-cell-width{
  min-width: 150px
}

/deep/ .xmedium-cell-width{
  min-width: 160px
}

/deep/ .large-cell-width{
  min-width: 200px
}
table {
  border-collapse: collapse;
  border-spacing: 0 0em;
}
 /deep/ .table td {
  padding: 5px !important;
}
/deep/ .table th, td {
  padding: 6px !important;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}
/deep/ .table {
    width: 120% !important;
}
</style>


// WEBPACK FOOTER //
// src/views/reports/auditLogs.vue